/**
 * Help Center - Modular Entry Point
 *
 * This is the new modular version of the help center system.
 * It imports and orchestrates all the separate modules for better maintainability.
 *
 * To use this modular system:
 * 1. Replace the script tag in your Liquid template from:
 *    <script src="{{ 'help-center.js' | asset_url }}" defer></script>
 * 2. To:
 *    <script src="{{ 'help-center-modular.js' | asset_url }}" type="module" defer></script>
 *
 * All functionality remains exactly the same - this is just a cleaner, more maintainable structure.
 */

import { HelpCenter } from "./help-center-main.js";

// The main class is already initialized in help-center-main.js
// This file serves as the entry point for the modular system

// Export the main class for external use if needed
export { HelpCenter };

// Expose the API instance for backward compatibility
// Note: The main instance is created in help-center-main.js and exposed via window.helpCenterInstance
// We'll expose the API class for any external usage
import { HelpCentreAPI } from "./help-center-api.js";
window.HelpCentreAPI = HelpCentreAPI;
